import { render, staticRenderFns } from "./bank-history-block.vue?vue&type=template&id=6a57d948"
import script from "./bank-history-block.vue?vue&type=script&lang=ts"
export * from "./bank-history-block.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports